module.exports = __webpack_public_path__ + "img/fola-esch.0e2df805.png";